import { lbToast } from '@linearb/buzz'
import { APP_URL, IS_PROD_TIER } from '../constants/apis'

export const showSupportAccountSuccessToast = (): void => {
  lbToast({
    title: 'Success',
    description: (
      <>
        Support account was set successfully! <br />
        <a
          href={APP_URL}
          target='_blank'
          rel='noopener noreferrer'
          className={`underline font-medium ${
            IS_PROD_TIER
              ? 'text-white hover:text-white/80'
              : 'text-primary hover:text-primary/80'
          }`}
        >
          Open LinearB →
        </a>
      </>
    ) as any,
    // Green only on prod — a plain white toast is the cue you're on a dev env.
    variant: IS_PROD_TIER ? 'success' : 'default'
  })
}

export const showSupportAccountErrorToast = (): void => {
  lbToast({
    title: 'Error',
    description: 'Failed to set support account',
    variant: 'destructive'
  })
}
